module.exports = __webpack_public_path__ + "components/assets/loader-cdae69e2f6e661bdc1b1f0a054a39958.gif";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/assets/loader.gif
// module id = 209
// module chunks = 0 1